// extracted by mini-css-extract-plugin
module.exports = {"countdown-container":"style_countdown-container__2O93M","item":"style_item__1HKTA","name":"style_name__377Fi","number":"style_number__MsuMP"};